
export default {
    methods: {
        //获取详情
        getDictDetail(dictname) {
            let dictAlls = this.$store.state.distAll
            let dictDetail = dictAlls.filter(item => item.name === dictname)
            return dictDetail.length>0?dictDetail[0].dictDetails:[]
        },
        //根据类型值显示对应名字
        getDictName(dictDetail, val) {
            let dictName = ''
            dictDetail.forEach(item => {
                if (item.value == val) dictName = item.label
            });
            return dictName
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/dictMixins.js